import classnames from 'classnames';

import type { MouseEvent } from 'react';

import styles from './index.css';

export interface ButtonUIProp {
    className?: string;
    icon?: string;
    text?: string;
    notification?: boolean;
    onClick?: (event: MouseEvent) => void;
    small?: boolean;
    shadow?: boolean;
}

const ButtonUI: React.FC<ButtonUIProp> = ({
    className,
    icon,
    text,
    small,
    shadow,
    notification = false,
    onClick = () => {},
    children,
}) => (
    <div
        className={classnames(
            styles.buttonUI,
            icon && styles.withHover,
            small && styles.small,
            shadow && styles.shadow,
            className,
        )}
        role="button"
        tabIndex={0}
        onKeyPress={() => {}}
        onClick={onClick}
    >
        {icon ? <img className={styles.icon} src={icon} alt="icon" /> : children}
        {!small && <div className={styles.text}>{text}</div>}
        {notification && (
            <div className={styles.notification}>
                <div className={styles.dot} />
            </div>
        )}
    </div>
);

export default ButtonUI;
